import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import QualificationAccordionSummary from './QualificationAccordionSummary';

import DepotGestionSelect from 'components/Shared/DepotGestionSelect';
import AdresseForm from 'components/Shared/AdresseForm';
import QualificationTextField from 'components/Shared/QualificationTextField';


const gestionTransportLabel = "Transport géré par : ";
const gestionTransportLabels = [
    "Foussier",
    "le fabricant"
];


const localisationLabel = "Où se trouve physiquement le produit  ?";
const localisations = [
    "Dans un magasin",
    "Chez le client",
    "Dépôt dans un point relais",
];



const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1),
        width: '100%'
    },

    group: {
        margin: theme.spacing(1, 0)
    },
});

class SavByFoussierBonTransport extends QualificationComponent {


    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            [ReclamationQualificationDetailCodes.SavByFoussierGestionTransport]: '',
            [ReclamationQualificationDetailCodes.LocalisationProduit]: '',
            [ReclamationQualificationDetailCodes.Depot]: this.props.codeDepot,
            [ReclamationQualificationDetailCodes.AdresseEnlevement]: '',
            [ReclamationQualificationDetailCodes.SavByFoussierRelais]: '',
            [ReclamationQualificationDetailCodes.SavByFoussierClientContactEnlevement]: '',
            [ReclamationQualificationDetailCodes.SavByFoussierClientInstructionsEnlevement]: '',
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.SavByFoussierGestionTransport,
            ReclamationQualificationDetailCodes.LocalisationProduit,
            ReclamationQualificationDetailCodes.Depot,
            ReclamationQualificationDetailCodes.AdresseEnlevement,
            ReclamationQualificationDetailCodes.SavByFoussierRelais,
            ReclamationQualificationDetailCodes.SavByFoussierClientContactEnlevement,
            ReclamationQualificationDetailCodes.SavByFoussierClientInstructionsEnlevement,
        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");

    }



    getQualificationData(newState) {

        const { name/*, garantie */ } = this.props;

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];


        // On vérifie que l'état est correct
        if (
            newState[ReclamationQualificationDetailCodes.SavByFoussierGestionTransport] === ''
            || newState[ReclamationQualificationDetailCodes.LocalisationProduit] === ''
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '0' && newState[ReclamationQualificationDetailCodes.Depot] === '')
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '1' && newState[ReclamationQualificationDetailCodes.AdresseEnlevement] === '')
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '1' && newState[ReclamationQualificationDetailCodes.SavByFoussierClientContactEnlevement] === '')
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '2' && newState[ReclamationQualificationDetailCodes.SavByFoussierRelais] === '')
        ) {
            return {
                name: name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            //position: toAdd.length,
            position: 0,
            code: ReclamationQualificationDetailCodes.SavByFoussierGestionTransport,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: gestionTransportLabel,
            valeurInteger: newState[ReclamationQualificationDetailCodes.SavByFoussierGestionTransport],
            valeurString: gestionTransportLabels[newState[ReclamationQualificationDetailCodes.SavByFoussierGestionTransport]]
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierGestionTransport);

        toAdd.push({
            //position: toAdd.length,
            position: 0,
            code: ReclamationQualificationDetailCodes.LocalisationProduit,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: localisationLabel,
            valeurInteger: newState[ReclamationQualificationDetailCodes.LocalisationProduit],
            valeurString: localisations[newState[ReclamationQualificationDetailCodes.LocalisationProduit]]
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.LocalisationProduit);


        if (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '0') {
            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.Depot,
                type: ReclamationQualificationDetailType.CodeDepot,
                libelle: "Adresse d'enlèvement (magasin)",
                valeurString: newState[ReclamationQualificationDetailCodes.Depot]
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.Depot)
        }

        if (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '1') {

            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.AdresseEnlevement,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Adresse d'enlèvement",
                valeurString: newState[ReclamationQualificationDetailCodes.AdresseEnlevement],

            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.AdresseEnlevement);

            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.SavByFoussierClientContactEnlevement,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Contact pour l'enlèvement",
                valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierClientContactEnlevement],

            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierClientContactEnlevement);

            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.SavByFoussierClientInstructionsEnlevement,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Instructions pour l'enlèvement",
                valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierClientInstructionsEnlevement],

            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierClientInstructionsEnlevement);


        }

        if (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '2') {

            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.SavByFoussierRelais,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Information sur le point relais",
                valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierRelais],

            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierRelais);

        }


        return {
            name: name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }


    render() {

        const { name, classes, adresseLivraison } = this.props;

        const localisationProduit = this.state[ReclamationQualificationDetailCodes.LocalisationProduit];


        return (


            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Création du bon de transport" />


                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>


                    <div className={classes.row}>
                        <FormControl required className={classes.formControl}>
                            <FormLabel>{gestionTransportLabel}</FormLabel>
                            <RadioGroup
                                name={ReclamationQualificationDetailCodes.SavByFoussierGestionTransport}
                                className={classes.group}
                                value={this.state[ReclamationQualificationDetailCodes.SavByFoussierGestionTransport]}
                                onChange={this.handleChange}
                            >
                                {gestionTransportLabels.map((reponse, index) => (
                                    <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                ))}
                            </RadioGroup>
                        </FormControl>
                    </div>


                    {this.state[ReclamationQualificationDetailCodes.SavByFoussierGestionTransport] !== '' && 
                        (<>


                            <div className={classes.row}>
                                <FormControl required className={classes.formControl}>
                                    <FormLabel>{localisationLabel}</FormLabel>
                                    <RadioGroup
                                        name={ReclamationQualificationDetailCodes.LocalisationProduit}
                                        className={classes.group}
                                        value={localisationProduit}
                                        onChange={this.handleChange}
                                >

                                    {this.state[ReclamationQualificationDetailCodes.SavByFoussierGestionTransport] === '0' && (

                                        localisations.map((reponse, index) => (
                                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                        ))
                                    )}

                                    {this.state[ReclamationQualificationDetailCodes.SavByFoussierGestionTransport] === '1' && (

                                        localisations.slice(0, -1).map((reponse, index) => (
                                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                        ))
                                    )}

                                    </RadioGroup>
                                </FormControl>
                            </div>

                            {/* Magasin */}
                            {localisationProduit === '0' && (

                                <div className={classes.row}>
                                    <DepotGestionSelect className={classes.formControl}
                                        value={this.state[ReclamationQualificationDetailCodes.Depot]}
                                        valueIsCode
                                        onChange={(e, codeDepot) => {
                                            this.handleChange({
                                                target: {
                                                    name: ReclamationQualificationDetailCodes.Depot,
                                                    value: codeDepot
                                                }
                                            });
                                        }}
                                        magasinsSeulement
                                        isRequired
                                        autoFocus
                                        label="Sélectionner un magasin :"
                                        modeTri={1}
                                    />
                                </div>
                            )}



                            {/* Client */}
                            {localisationProduit === '1' && (

                            <>
                                    <div style={{ paddingBottom: '8px' }}>
                                        <AdresseForm
                                            label={"Adresse d'enlèvement"}
                                            adresse={adresseLivraison}
                                            onChange={(addr, addrStr) => this.handleChange({ target: { name: ReclamationQualificationDetailCodes.AdresseEnlevement, value: addrStr } })}
                                        />
                                    </div>


                                    <QualificationTextField
                                        label={"Contact client"}
                                        name={ReclamationQualificationDetailCodes.SavByFoussierClientContactEnlevement}
                                        value={this.state[ReclamationQualificationDetailCodes.SavByFoussierClientContactEnlevement]}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <QualificationTextField
                                        label={"Instructions particulières"}
                                        name={ReclamationQualificationDetailCodes.SavByFoussierClientInstructionsEnlevement}
                                        value={this.state[ReclamationQualificationDetailCodes.SavByFoussierClientInstructionsEnlevement]}
                                        onChange={this.handleChange}
                                        multiline
                                    />


                                </>
                             )}



                            {/* Point relais */}
                            {localisationProduit === '2' && (

                                <QualificationTextField
                                    label={"Information sur le point relais"}
                                    name={ReclamationQualificationDetailCodes.SavByFoussierRelais}
                                    value={this.state[ReclamationQualificationDetailCodes.SavByFoussierRelais]}
                                    onChange={this.handleChange}
                                    required
                                />

                            )}




                        </>)
                    }





                </AccordionDetails>
            </Accordion>



        );
    }

}


SavByFoussierBonTransport.propTypes = {
    name: PropTypes.string.isRequired,
    codeDepot: PropTypes.string.isRequired,
    adresseLivraison: PropTypes.object
};

//SavByFoussierBonTransport.defaultProps = {
//};

export default withStyles(styles)(SavByFoussierBonTransport);